import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 20px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useState } from 'react';
import { useAsyncCallback } from 'react-async-hook';
import useAsyncEffect from 'use-async-effect';
import styled from '../../utils/styling/styled-components';
import { PrivateInputV3 } from '../TextInputsV3/PrivateInputV3';
import { useValidateField } from './hooks/useValidateField';
import { Container, Default, Error, Success, StyledPrivateInputV1, StyledPrivateInputV2, ValidatorContainer } from './styled-components';
import { ValidationTypes } from './types';
import { determinePasswordErrorState, generatePasswordValidationSchema, passwordErrorMap } from './utils';

var StyledPrivateInput = function StyledPrivateInput(_ref) {
  var inputVersion = _ref.inputVersion,
      props = _objectWithoutProperties(_ref, ["inputVersion"]);

  if (inputVersion === 'v1') {
    return /*#__PURE__*/React.createElement(StyledPrivateInputV1, {
      className: props.className,
      error: props.error,
      id: props.name,
      label: props.label,
      name: props.name,
      onChange: props.onChange,
      onFocus: props.onFocus,
      onBlur: props.onBlur,
      toggleIcon: props.toggleIcon,
      type: props.type,
      required: props.required,
      value: props.value,
      placeholder: props.placeholder
    });
  } else if (inputVersion === 'v2') {
    return /*#__PURE__*/React.createElement(StyledPrivateInputV2, {
      className: props.className,
      label: {
        value: props.label
      },
      inputProps: {
        id: props.id,
        name: props.name,
        value: props.value,
        onChange: props.onChange,
        onFocus: props.onFocus,
        onBlur: props.onBlur,
        required: props.required,
        type: props.type,
        placeholder: props.placeholder
      },
      error: props.error
    });
  } else {
    return /*#__PURE__*/React.createElement(PrivateInputV3, {
      className: props.className,
      label: {
        value: props.label
      },
      inputProps: {
        id: props.id,
        name: props.name,
        value: props.value,
        onChange: props.onChange,
        onFocus: props.onFocus,
        onBlur: props.onBlur,
        required: props.required,
        type: props.type,
        placeholder: props.placeholder
      },
      error: props.error
    });
  }
};

var ConfirmationPasswordField = styled(PrivateInputV3)(_templateObject());

var DynamicValidator = function DynamicValidator(_ref2) {
  var errorMap = _ref2.errorMap,
      field = _ref2.field,
      initialValues = _ref2.initialValues,
      value = _ref2.value,
      validationSchema = _ref2.validationSchema,
      setPasswordValidationResult = _ref2.setPasswordValidationResult,
      className = _ref2.className,
      passwordConfirmation = _ref2.passwordConfirmation;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      validationErrors = _useState2[0],
      setValidationErrors = _useState2[1];

  var _useValidateField = useValidateField(validationSchema),
      validateField = _useValidateField.validateField;

  var asyncValidateField = useAsyncCallback( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(values) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return validateField(values);

            case 2:
              return _context.abrupt("return", _context.sent);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }());
  useAsyncEffect( /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(isMounted) {
      var _objectSpread2;

      var values, data;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (isMounted) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              values = _objectSpread(_objectSpread({}, initialValues), {}, (_objectSpread2 = {}, _defineProperty(_objectSpread2, field, value), _defineProperty(_objectSpread2, passwordConfirmation === null || passwordConfirmation === void 0 ? void 0 : passwordConfirmation.name, passwordConfirmation === null || passwordConfirmation === void 0 ? void 0 : passwordConfirmation.value), _objectSpread2));
              _context2.next = 5;
              return asyncValidateField.execute(values);

            case 5:
              data = _context2.sent;
              setValidationErrors(data);
              if (setPasswordValidationResult) setPasswordValidationResult(!!data);

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref4.apply(this, arguments);
    };
  }(), [value, passwordConfirmation === null || passwordConfirmation === void 0 ? void 0 : passwordConfirmation.value]);

  var interpretErrors = function interpretErrors(label, data) {
    var _data$errors;

    if (data === null || data === void 0 ? void 0 : (_data$errors = data.errors) === null || _data$errors === void 0 ? void 0 : _data$errors.includes(label)) {
      return ValidationTypes.Error;
    } else {
      return ValidationTypes.Success;
    }
  };

  var ValidationItem = function ValidationItem(_ref5) {
    var label = _ref5.label,
        message = _ref5.message,
        validationType = _ref5.validationType;

    if (validationType === ValidationTypes.Success) {
      return /*#__PURE__*/React.createElement(Success, {
        "data-testid": "validation-item-success-".concat(label)
      }, message);
    } else if (validationType === ValidationTypes.Error) {
      return /*#__PURE__*/React.createElement(Error, {
        "data-testid": "validation-item-error-".concat(label)
      }, message);
    } else {
      return /*#__PURE__*/React.createElement(Default, {
        "data-testid": "validation-item-default-".concat(label)
      }, message);
    }
  };

  return /*#__PURE__*/React.createElement(ValidatorContainer, {
    className: className
  }, errorMap === null || errorMap === void 0 ? void 0 : errorMap.map(function (element) {
    return /*#__PURE__*/React.createElement(ValidationItem, {
      key: element.label,
      label: element.label,
      validationType: (value === null || value === void 0 ? void 0 : value.length) > 0 ? interpretErrors(element === null || element === void 0 ? void 0 : element.label, validationErrors) : ValidationTypes.Default,
      message: element.message
    });
  }));
};

export var MemoizedDynamicFieldValidator = /*#__PURE__*/React.memo(DynamicValidator);
export var PasswordInputV4 = function PasswordInputV4(_ref6) {
  var _initialValues;

  var errors = _ref6.errors,
      name = _ref6.name,
      value = _ref6.value,
      label = _ref6.label,
      onChange = _ref6.onChange,
      onFocus = _ref6.onFocus,
      onBlur = _ref6.onBlur,
      inputVersion = _ref6.inputVersion,
      _ref6$required = _ref6.required,
      required = _ref6$required === void 0 ? false : _ref6$required,
      _ref6$toggleIcon = _ref6.toggleIcon,
      toggleIcon = _ref6$toggleIcon === void 0 ? false : _ref6$toggleIcon,
      className = _ref6.className,
      placeholder = _ref6.placeholder,
      _ref6$showPasswordCon = _ref6.showPasswordConfirmationField,
      showPasswordConfirmationField = _ref6$showPasswordCon === void 0 ? false : _ref6$showPasswordCon,
      passwordConfirmation = _ref6.passwordConfirmation;

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      passwordValidationResult = _useState4[0],
      setPasswordValidationResult = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      errorState = _useState6[0],
      setErrorState = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      confirmPasswordFieldDisabled = _useState8[0],
      setConfirmPasswordFieldDisabled = _useState8[1];

  var initialValues = (_initialValues = {}, _defineProperty(_initialValues, name, ''), _defineProperty(_initialValues, passwordConfirmation === null || passwordConfirmation === void 0 ? void 0 : passwordConfirmation.name, ''), _initialValues);
  useAsyncEffect(function (isMounted) {
    if (!isMounted) return;
    setErrorState(determinePasswordErrorState(errors, !!passwordValidationResult, value.length, passwordConfirmation === null || passwordConfirmation === void 0 ? void 0 : passwordConfirmation.errorText));

    if (value.length === 0) {
      setConfirmPasswordFieldDisabled(true);
    } else {
      setConfirmPasswordFieldDisabled(false);
    }
  }, [value, errors, passwordValidationResult]);
  return /*#__PURE__*/React.createElement(Container, {
    className: className
  }, /*#__PURE__*/React.createElement(StyledPrivateInput, {
    inputVersion: inputVersion,
    error: errorState,
    id: name,
    label: label,
    name: name,
    onChange: onChange,
    onFocus: onFocus,
    onBlur: onBlur,
    required: required,
    toggleIcon: toggleIcon,
    type: "password",
    value: value,
    placeholder: placeholder
  }), showPasswordConfirmationField && /*#__PURE__*/React.createElement(ConfirmationPasswordField, {
    error: errorState,
    label: {
      value: passwordConfirmation.label
    },
    inputProps: {
      onChange: passwordConfirmation.onChange,
      disabled: confirmPasswordFieldDisabled,
      name: passwordConfirmation.name,
      placeholder: 'Confirm New Password',
      value: passwordConfirmation.value
    },
    isRevealable: true,
    errorText: passwordConfirmation.errorText
  }), /*#__PURE__*/React.createElement(MemoizedDynamicFieldValidator, {
    errorMap: passwordErrorMap(showPasswordConfirmationField),
    field: name,
    initialValues: initialValues,
    value: value,
    passwordConfirmation: passwordConfirmation,
    setPasswordValidationResult: setPasswordValidationResult,
    validationSchema: generatePasswordValidationSchema(showPasswordConfirmationField, name, passwordConfirmation === null || passwordConfirmation === void 0 ? void 0 : passwordConfirmation.name)
  }));
};